var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M12.578 1.049a.71.71 0 0 0-.644-.37.7.7 0 0 0-.518.203l-9.198 9.02a.708.708 0 0 0 .99 1.011l8.04-7.885v19.585a.708.708 0 1 0 1.415 0V3.115l7.951 7.798a.708.708 0 0 0 .991-1.01z",
    clipRule: "evenodd"
  })));
};
export default SvgUp;